/* eslint-disable */
// TODO: check es lint errors
class JumpList {
  constructor(element, options) {
    this._element = element;
    this._options = { ...JumpList.options, ...options };

    // Bind
    this._handleChange = this._handleChange.bind(this);

    // Events
    this._element.addEventListener('change', this._handleChange);
  }

  _handleChange(event) {
    try {
      this._element.form.submit();
    } catch (ex) {}
  }
}

export default JumpList;
/* eslint-enable */
